module.exports = __webpack_public_path__ + "img/7left-n-2027c7ff.png";